/**
 * Persists and restores nested/inner wizard steps via sessionPersistence.
 * Use a stable parent step id (e.g. 'step1', 'step2')
 */
import { useCallback, useState } from 'react'
import { useAppSelector } from 'store/hooks'
import { getSessionId } from 'store/slices/test'
import {
  getPersistedInnerStep,
  persistInnerStep,
} from 'services/sessionPersistence'

const useNestedStep = (
  parentStep: string,
  defaultInnerStep = 1
): readonly [number, (next: number) => void] => {
  const sessionId = useAppSelector(getSessionId)

  const [innerStep, setInner] = useState(() =>
    getPersistedInnerStep(sessionId, parentStep) ?? defaultInnerStep
  )

  const setInnerStep = useCallback(
    (next: number) => {
      setInner(next)
      persistInnerStep(sessionId, parentStep, next)
    },
    [sessionId, parentStep]
  )

  return [innerStep, setInnerStep] as const
}

export default useNestedStep
